import Component from '../inherited/Component'
import { create } from 'evx'
import Helpers from '../lib/Helpers'
import KeenSlider from 'keen-slider'

export default class KeenSliderComp extends Component {
  constructor (elem, theme, options, ctx) {
    options = {...{
      dragSpeed: 1,
      autoplaySpeed: 5000,
      duration: 500,
      arrowSvg: `
              <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.7371 0.403587L13.7371 0.403591L7.99998 6.14146L2.26288 0.403591L2.26288 0.403587C2.12685 0.267558 1.94236 0.191138 1.74998 0.191138C1.55761 0.191138 1.37311 0.267558 1.23708 0.403587C1.10105 0.539616 1.02463 0.724111 1.02463 0.916485C1.02463 1.10886 1.10105 1.29335 1.23708 1.42938L7.48704 7.67934L7.48708 7.67938L7.55779 7.60867C7.61584 7.66678 7.68477 7.71288 7.76064 7.74434C7.83652 7.77579 7.91785 7.79198 7.99998 7.79198C8.08212 7.79198 8.16344 7.77579 8.23932 7.74434C8.31519 7.71288 8.38412 7.66678 8.44217 7.60867L13.7371 0.403587ZM13.7371 0.403587C13.8044 0.336232 13.8844 0.282803 13.9724 0.246351C14.0604 0.209899 14.1547 0.191138 14.25 0.191138C14.3452 0.191138 14.4396 0.209899 14.5276 0.246351C14.6156 0.282803 14.6955 0.336232 14.7629 0.403587C14.8302 0.470942 14.8837 0.550904 14.9201 0.638907C14.9566 0.726909 14.9753 0.82123 14.9753 0.916485C14.9753 1.01174 14.9566 1.10606 14.9201 1.19406C14.8837 1.28207 14.8302 1.36203 14.7629 1.42938L8.51292 7.67934L13.7371 0.403587Z" fill="#042364" stroke="#042364" stroke-width="0.2"/>
              </svg>
              `
    }, ...options}
    let optionsCopy = {...options}
    super(elem, theme, options, ctx)
    this._slider = null
    this._autoplayInterval = null
    this.shouldAutoplay = false
    this._localCtx = create()
    this._isMounted = false
    this._addedListener = false
    super.reinitOnResize(optionsCopy)
  }

  mount () {
    if (this._options.mount === false) {
      return false
    }

    if (this._options.enableWhen && !this._addedListener) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      this._addedListener = true
    }

    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      return false
    }

    this._convertOldOptions()

    this._slidesPerView = typeof this._options.slides === 'object' ? (this._options.slides.perView || this._options.slides.number) : this._options.slides
    
    this._elem.classList.add('keen-slider')
    for (let elem of this._elem.children) {
      if (elem.hasAttribute('data-keen-dots') || elem.hasAttribute('data-keen-nav')) continue
      elem.classList.add('keen-slider__slide')
      if (this._options.fade) {
        elem.classList.add('fader-slide')
      }
    }
    this._slides = this._elem.querySelectorAll('.keen-slider__slide')

    // AS NAV FOR
    if (this._options.asNavFor) {
      this._ctx.on('ffc--mounted', e => {
        this._parentSlider = this._theme.getComponent(this._options.asNavFor)
        this._parentSlider = this._parentSlider.component

        this._parentSliderTimeout = null

        this._parentSlider._localCtx.on('slide-change', (state, data) => {
           console.log(data.slider.track.details.rel)

           if (this._parentSliderTimeout) clearTimeout(this._parentSliderTimeout)

            this._parentSliderTimeout = setTimeout(() => {
              const next = data.slider.track.details.rel || 0
              this.goToSlide(data.slider.track.details.rel)
            }, 100)

           
        })
      })
    }

    if (this._options.arrows) this._createArrows()
    if (this._options.dots && this._slides.length > 1) this._createDots()
    

    if (this._slides.length === this._slidesPerView) {
      this._options.loop = false
      this._options.controls = false
    }

    this._dotsContainer = this._options.dotsContainer ? document.querySelector(this._options.dotsContainer) || this._elem : this._elem
    this._dots = this._dotsContainer.querySelectorAll('[data-dot]')

    if (!this._prevArrows) this._prevArrows = this._elem.querySelectorAll('[data-keen-prev]')
    if (!this._nextArrows) this._nextArrows = this._elem.querySelectorAll('[data-keen-next]')

    this._options.animationStarted = slider => {
      this._localCtx.emit('animation-started', null, { slider: slider })
    }

    this._options.slideChanged = (slider) => {
      this.updateClasses(slider)
      this.updateFadeHeight(slider)
      this._localCtx.emit('slide-change', null, { slider: slider })
      this.adaptiveHeight(slider)
      if (this._isMounted) this.scrollRevealFix(slider)

      this._pauseVideos()
      if (this._options.playVideos) this._playVideos(slider)
      if (this._options.setSlideCount) this._setSlideCount(slider)

      this._doSlideCSSVars(slider)


      if(this._options.emit) {
        this._ctx.emit(this._options.emit.event, this._options.emit.payload)
      }
      

      // if (this._options.asNavFor && this._parentSlider) {
      //   let parentSlider = this._parentSlider._slider
      //   console.log(this._slider)
      //   const next = this._slider.track.details.rel || 0
      //   parentSlider.moveToIdx(Math.min(parentSlider.track.details.maxIdx, next))
      // }
    }

    this._options.animationEnded = (slider) => {
      if (this._options.namespace) {
        this._ctx.emit('keen-slider:change', {
          namespace: this._options.namespace,
          activeSlide: slider.track.details.rel,
        })
      }

      if (this._options.asNavFor && this._parentSlider) {
        let parentSlider = this._parentSlider._slider
        const next = this._slider.track.details.rel || 0
        parentSlider.moveToIdx(Math.min(parentSlider.track.details.maxIdx, next))
      }
    }

    this._options.created = (slider) => {
      this._elem.classList.add('keen-slider--ready')
      this.updateClasses(slider)
      this.updateFadeHeight(slider)
      this.adaptiveHeight(slider)
      this._doSlideCSSVars(slider)

      if (this._options.autoplay) this._setupAutoplay(slider)
      if (this._options.autoplayWhenVisibleOnly) this._doAutoplayOnScroll()
      if (this._options.alignArrowsTo) this.alignArrows()
      if (this._options.arrowKeyNavigation) this._addArrowKeyEvents()
      if (this._options.playVideos) this._playVideos(slider)
      if (this._options.setSlideCount) this._setSlideCount(slider)
      if (this._options.focusOnSelect) this.focusOnSelect(slider)

      window.addEventListener('resize', e => {
        this.updateFadeHeight()
        this.adaptiveHeight()

        if (this._options.alignArrowsTo) {
          Helpers.nextFrame(() => {
            this.alignArrows()
          })
        }
      }, { passive: true })

      this._ctx.on('radiant--slider-update', e => {
        this.updateFadeHeight()
        this.adaptiveHeight()

        if (this._options.alignArrowsTo) {
          Helpers.nextFrame(() => {
            this.alignArrows()
          })
        }
      })

    }

    this._options.dragStarted = () => {
      this.shouldAutoplay = false
    }

    this._options.dragEnded = () => {
      this.shouldAutoplay = true
    }
    
    if (this._options.fade) {
      this._options.detailsChanged = (slider) => this.fader(slider)
      this._options.renderMode = 'custom'
    }

    this._slider = new KeenSlider(this._elem, this._options)

    if (this._prevArrows) {
      for(let arrow of this._prevArrows) {
        arrow.addEventListener('click', e => this.goToPrev(e))
      }
    } 

    if (this._nextArrows) {
      for(let arrow of this._nextArrows) {
        arrow.addEventListener('click', e => this.goToNext(e))
      }
    }

    for (let dot of this._dots) {
      dot.addEventListener('click', e => {
        e.preventDefault()
        this.goToSlide(Number(dot.dataset.dot))
 
        if (this._parentSlider) {
          this._parentSlider.goToSlide(Number(dot.dataset.dot))
        }
      })
    }

    this._isMounted = true

    if (this._options.triggerOnMount) {
      this._ctx.emit(this._options.triggerOnMount)
    }
  }

  focusOnSelect (slider = this._slider) {
    for (let [index, slide] of this._slides.entries()) {
      slide.addEventListener('click', e => {
        this.goToSlide(index)
      })
    }
  }

  _setSlideCount(slider = this._slider) {
    let slideCountParentElem = document.querySelector(this._options.setSlideCount)
    let totalElem = slideCountParentElem.querySelector('[data-slide-total]')
    let currentElem = slideCountParentElem.querySelector('[data-slide-current]')

    totalElem.innerHTML = slider.details().size
    currentElem.innerHTML = slider.details().relativeSlide + 1

    if (this.isAtEnd(slider) && slider.details().relativeSlide == 0) {
      slideCountParentElem.classList.add('hide')
    }
  }

  unmount () {
    if (this._slider) {
      this._slider.destroy()
    }
    if (this._navContainer && this._navContainer.parentNode) {
      this._navContainer.parentNode.removeChild(this._navContainer)
    }
    let dots = this._elem.querySelector('[data-keen-dots]');
    if (dots) {
      dots.parentNode.removeChild(dots);
    }
    this._elem.classList.remove('keen-slider')
    for (let elem of this._elem.children) {
      elem.classList.remove('keen-slider__slide')
      elem.classList.remove('fader-slide')
      elem.removeAttribute('style')
    }
    this._elem.style.height = ''
  }

  _setupAutoplay (slider) {
    if (!this._options.autoplay) {
      clearTimeout(this.autoplayTimeout)
      return false
    }

    this.shouldAutoplay = true
    this.shouldAutoplayVisible = true

    if (this._options.pauseAutoplayOnHover) {
      this._elem.addEventListener('mouseover', e => {
        this.shouldAutoplay = false
        clearTimeout(this.autoplayTimeout)
      })

      this._elem.addEventListener('mouseout', e => {
        this.shouldAutoplay = true
        this.autoplay()
      })
    }

    this.autoplay()

    slider.on('dragStarted', () => {
      if (this.autoplayTimeout) clearTimeout(this.autoplayTimeout)
    })

    slider.on('animationEnded', () => {
      this.autoplay()
    })

    slider.on('updated', () => {
      this.autoplay()
    }) 

  }

  autoplay () {
    clearTimeout(this.autoplayTimeout)
    this.autoplayTimeout = setTimeout(() => {
      if (!this.shouldAutoplay || !this.shouldAutoplayVisible) return

      if (this._slider) {
        if (this.isAtEnd() && !this._options.loop) {
          this.goToSlide(0)
        } else {
          this._slider.next()
        }
      }
    }, this._options.autoplaySpeed)
  }

  _doAutoplayOnScroll () {
    if (!this._options.autoplay) return false

    let visibleCheck = () => {
      if(Helpers.isInViewport(this._elem) && this.shouldAutoplayVisible == false) {
        this.shouldAutoplayVisible = true
        this.autoplay()
      } else {
        this.shouldAutoplayVisible = false
        if (this.autoplayTimeout) clearTimeout(this.autoplayTimeout)
      }
    }
    
    window.addEventListener('scroll', e => {
      visibleCheck()
    }, { passive: true })
    visibleCheck()
  }

  _doSlideCSSVars (slider = this._slider) {
    let slide = this.getActiveSlideElem(slider)

    if (slide && slide.dataset.slideCssVars) {
      let varArr = JSON.parse(slide.dataset.slideCssVars);

      for (let cssVar of varArr) {
        let toSetOn = document.querySelector(cssVar.onElem)

        for (let classStr of toSetOn.classList) {
          if (classStr.includes(cssVar.class.replace('[value]', ''))) {
            toSetOn.classList.remove(classStr)
          }
        }

        if (toSetOn) {
          toSetOn.classList.add(cssVar.class.replace('[value]', cssVar.value))
        }
      }
    }
  }

  _addArrowKeyEvents () {
    document.addEventListener('keydown', e => {
      let ev = e || window.event;
      if (ev.keyCode === 37) {
         // left arrow
         this._slider.prev()
      } else if (ev.keyCode === 39) {
         // right arrow
         this._slider.next()
      }
    })
  }

  _createArrows () {
    var e = document.createElement('ul');
    e.classList.add('keen-nav')
    e.setAttribute('data-keen-nav', true)
    e.innerHTML = `
        <li>
          <button data-keen-prev class="keen-arrow-prev keen-arrow" aria-label="Previous Slide">
            <span class="keen-arrow-inner">
              ${this._options.arrowSvg || ''}
            </span>
          </button>
        </li>
        <li>
          <button data-keen-next class="keen-arrow-next keen-arrow" aria-label="Next Slide">
            <span class="keen-arrow-inner">
              ${this._options.arrowSvg || ''}
            </span>
          </button>
        </li>
    `;
    this._navContainer = e

    if (this._options.appendArrows) {
      let toAppend = document.querySelectorAll(this._options.appendArrows)
      if (toAppend) {
        for(let appendElem of toAppend) {
          let arrows = e.cloneNode(true)
          appendElem.appendChild(arrows) 
        }
      }
    } else {
      this._elem.appendChild(e) 
    }

    this._prevArrows = this._elem.querySelectorAll('[data-keen-prev]')
    this._nextArrows = this._elem.querySelectorAll('[data-keen-next]')
  }

  _createDots () {
    var e = document.createElement('ul');
    e.classList.add('keen-dots')
    e.setAttribute('data-keen-dots', true)

    let dotsToMake = Math.ceil(this._slides.length / this._slidesPerView)

    if(this._options.allDots) {
      dotsToMake = Math.ceil(this._slides.length)
    }

    for (let i = 0; i < dotsToMake; i++) {
      let index = i * this._slidesPerView
      if(this._options.allDots) {
        index = i
      }
      e.innerHTML += `
        <li>
          <button data-dot='${index}'></button>
        </li>
      `
    }

    this._elem.classList.add('keen--dotted')
    this._elem.appendChild(e) 
  }

  _playVideos (slider = this._slider) {
    this._pauseVideos()

    Helpers.nextFrame(() => {
      let active = this.getActiveSlideElem()
      let activeVideo = active.querySelector('video')

      if (activeVideo) {
        if (activeVideo.hasAttribute('[data-lazy]') && !activeVideo.classList.contains('loaded')) {
          activeVideo.addEventListener('ffc--loaded', e => {
            console.log('loaded Event')
            activeVideo.play()
          })
        } else {
          activeVideo.play()
        }
      }
    })
  }

  _pauseVideos () {
    let videos = this._elem.querySelectorAll('video')
    for (let video of videos) {
      video.pause()
    }
  }

  fader (slider = this._slider) {
    for (let [index, slide] of slider.slides.entries()) {
      slide.style.opacity = slider.track.details.slides[index].portion
    }
  }

  goToSlide (index, dontAnimate = false) {
    if (!this._slider) return
      
    let duration = dontAnimate ? 0 : this._options.duration

    let nearest = false

    if (this._options.loop && this._slider.track.details.slides.length > 2) {
       nearest = true
    }

    index = Number(index)

    this._slider.moveToIdx(index, nearest, duration)

    for (let dot of this._dots) {
      dot.classList.remove('active')

      if (Number(dot.dataset.dot) === index) {
        dot.classList.add('active')
      }
    }

    for (let slide of this._slides) {
      slide.classList.remove('is-active')
    }

    this._slides[index].classList.add('is-active')
  }

  goToPrev (e) {
    e.preventDefault()
    this._slider.prev()
  }

  goToNext (e) {
    e.preventDefault()
    this._slider.next()
  }

  scrollRevealFix () {
    for (let slide of this._slides) {
      if (slide.hasAttribute('data-sr-id') || slide.hasAttribute('data-reveal')) {
        slide.style.removeProperty('opacity')
        slide.style.removeProperty('transition')
        slide.style.removeProperty('visibility')
        slide.removeAttribute('data-sr-id')
        slide.removeAttribute('data-reveal')
      }
    }
  }

  getActiveSlideElem (slider = this._slider) {
    let slideIndex = slider.track.details.rel

    for (let [index, slide] of this._slides.entries()) {
      if (index === slideIndex) {
        return slide
      }
    }

    return false
  }

  adaptiveHeight (slider = this._slider) {
    if (!this._options.adaptiveHeight || !slider) return false

    this._elem.classList.add('keen--adaptive-height')
  
    Helpers.nextFrame(() => {
      let slide = slider.track.details.rel
      
      let height = 0

      height += parseFloat(getComputedStyle(this._elem).paddingBottom)
      height += parseFloat(getComputedStyle(this._elem).paddingTop)

      let activeSlide = this.getActiveSlideElem(slider)

      if (!activeSlide) return

      height += activeSlide.clientHeight
      this._elem.style.height = `${height}px`
    })
  }

  updateFadeHeight (slider = this._slider) {
    if (!this._options.fade || !slider) return false

    let slide = slider.track.details.rel
    
    let height = 0

    height += parseFloat(getComputedStyle(this._elem).paddingBottom)
    height += parseFloat(getComputedStyle(this._elem).paddingTop)

    let activeSlide = this.getActiveSlideElem(slider)
    if (!activeSlide) return

    height += activeSlide.getBoundingClientRect().height

    this._elem.style.height = `${height}px`

    if (!this._elem.classList.contains('fade-slider')) {
      this._elem.classList.add('fade-slider')
    }
  }

  alignArrows () {
    if (!this._options.alignArrowsTo || !this._navContainer) return false
    let elem = this._elem.querySelector(this._options.alignArrowsTo)
    this._navContainer.style.top = `${elem.clientHeight / 2}px`
  }

  updateClasses (slider) {
    if (!slider) return false

    let slide = slider.track.details.rel
    let maxSlides = slider.track.details.slides.length
    let perView = this._slidesPerView
    let endSlide = slide + perView

    let canSlide = perView !== maxSlides

    if (this._prevArrows && !this._options.loop) {
      if (slide === 0 || !canSlide) {
        for(let arrow of this._prevArrows) {
          arrow.setAttribute('disabled', 'disabled')
        }
      } else {
        for(let arrow of this._prevArrows) {
          arrow.removeAttribute('disabled')
        }
      }
    }

    if (this._nextArrows && !this._options.loop) {
      if (this.isAtEnd(slider) || !canSlide) {
        for(let arrow of this._nextArrows) {
          arrow.setAttribute('disabled', 'disabled')
        }
      } else {
        for(let arrow of this._nextArrows) {
          arrow.removeAttribute('disabled')
        }
      }
    }

    let activeSlide = this.getActiveSlideElem(slider)

    for (let slide of this._slides) {
      slide.classList.remove('active')
    }

    if (activeSlide) {
      activeSlide.classList.add('active')
    }

    if (this._dots) {
      for (let dot of this._dots) {
        dot.classList.remove('active')

        if (Number(dot.dataset.dot) === slide) {
          dot.classList.add('active')
        }
      }
    }

    let idx = slider.track.details.maxIdx
    let totalSlides = idx === Infinity ? maxSlides : idx + 1

    this._elem.style.setProperty('--current-slide', slide + 1)
    this._elem.style.setProperty('--total-slides', totalSlides)

    if (this._options.progressSelector) {
      let progressElem = document.querySelector(this._options.progressSelector)
      if(progressElem) {
        progressElem.style.setProperty('--current-slide', slide + 1)
        progressElem.style.setProperty('--total-slides', totalSlides)

        if (totalSlides === 1) {
          progressElem.classList.add('hide')
        }
      }
    }
  }

  isAtEnd (slider = this._slider) {
    let slide = slider.track.details.rel
    let maxSlides = slider.track.details.slides.length
    let perView = this._slidesPerView
    let endSlide = slide + Math.floor(perView)

    return endSlide >= maxSlides
  }

  refresh () {
    return this._slider.refresh()
  }

  resize () {
    return this._slider.resize()
  }

  forceUpdate() {
    this._elem.classList.remove('keen-slider--ready')
    Helpers.nextFrame(() => {
      this.unmount()
      this.mount()
      if (typeof this.update === 'function') {
        this.update()
      }
    })
  }

  _convertOldOptions() {
    if (this._options.slidesPerView) {
      this._options.slides = this._options.slides || {}
      this._options.slides.perView = this._options.slidesPerView
      delete this._options.slidesPerView
    }

    if (this._options.spacing) {
      this._options.slides.spacing = this._options.spacing
    }
  }
}